import { getReferenceTypeFromExternalOptionsProperty } from '../internal/getReferenceTypeFromExternalOptionsProperty';
export function isExternalOptionsProperty(property, objectTypeId) {
  return Boolean(getReferenceTypeFromExternalOptionsProperty(property, objectTypeId));
}